module.exports = __webpack_public_path__ + "static/media/eredin.2ef41c03.png";